import { LIST_ACTIONS } from 'lib/list-helper/makeListReducer';
import useQueryList from 'lib/list-helper/useQueryList';
import { reducer, initialState } from './sourcesListReducer';
import sourcesService from './sourcesService';
import debounce from 'lodash.debounce';

const fetchSources = debounce((params, _, dispatch) => {
  dispatch({ type: LIST_ACTIONS.SET_LOADING, payload: true });

  return sourcesService
    .getSources(params)
    .then((results) => {
      dispatch({
        type: LIST_ACTIONS.APP_LOADS_DATA,
        payload: { ...results },
      });
      return results;
    })
    .catch((e) => {
      dispatch({
        type: LIST_ACTIONS.SHOW_ERROR,
        payload: e.message,
      });
    })
    .then(() => {
      dispatch({ type: LIST_ACTIONS.SET_LOADING, payload: false });
    });
}, 400);

const useSourcesList = ({ location, history }) => {
  const list = useQueryList(
    location,
    history,
    reducer,
    initialState,
    fetchSources,
  );

  const userClicksOnRow = (id) => {
    history.push(`/sources/${id}`);
  };

  return { ...list, userClicksOnRow };
};

export default useSourcesList;
